import React from "react";
import {BaseTitleFragment} from "../BaseTitleFragment";
import {StyledEmpty} from "../../shared/StyledComponents";
import {NotificationsOutlined} from "@mui/icons-material";
import {LoginSpec} from "../../shared/PageFragment";

export class NotificationsFragment extends BaseTitleFragment {

  protected getTitle(): string {
    return "Notifications";
  }

  protected createLoginSpec(): LoginSpec | null {
    return {
      needsLogin: true,
      redirectAfterLoginPath: "/notifications",
    };
  }

  protected renderPageContent(): React.ReactElement {
    return <StyledEmpty emptyConfig={{
      title: "No notifications found",
      text: "You're all caught up.",
      iconType: NotificationsOutlined,
    }}/>;
  }
}